import { useCallback } from "react";
import { useHistory } from "react-router";

import { usePreviousLocation } from "@/utilities/PreviousLocation";

// 登録方法をまだ選んでいない画面には、保存確認を開く入力フォームがない。
// アプリ内から来た場合は元の画面へ、直接開いた場合は物件一覧へ戻す。
export const useRegistrationExit = (fallbackPath: string): (() => void) => {
  const history = useHistory();
  const previousLocation = usePreviousLocation();
  return useCallback(() => {
    if (previousLocation && previousLocation !== history.location.pathname) history.goBack();
    else history.replace(fallbackPath);
  }, [history, previousLocation, fallbackPath]);
};
